import { RouteBGColor, TaskBGColor, TaskState } from "../../models/core";

export class TaskStateColor {
    static getTaskStatusColor(TaskStatus:string) {
        const taskState = TaskStatus.toLowerCase();
        let TaskStateColor = "";
        switch (taskState) {
            case TaskState.Planned:
                TaskStateColor = TaskBGColor.Planned;
                break;
            case TaskState.Loaded:
                TaskStateColor = RouteBGColor.Loading;
                break;
            case TaskState.Requested:
                TaskStateColor = TaskBGColor.Requested;
                break;
            case TaskState.Completed:
                TaskStateColor = TaskBGColor.Completed;
                break;
            case TaskState.Notacted:
                TaskStateColor = TaskBGColor.Notacted;
                break;
            case TaskState.Rejected:
                TaskStateColor = TaskBGColor.Rejected;
                break;
            case TaskState.Unplanned:
                TaskStateColor = TaskBGColor.Unplanned;
                break;
            default:
                TaskStateColor = '#000';
                break;
        }
        return TaskStateColor
    }
}